import moment from 'moment'
import { TFunction } from 'i18next'

export const formatDuration = (durationMilliseconds: number, t: TFunction): string => {
  const duration = moment.duration(durationMilliseconds)

  const days = Math.floor(duration.asDays())
  duration.subtract(moment.duration(days, 'days'))

  const hours = duration.hours()
  duration.subtract(moment.duration(hours, 'hours'))

  const minutes = duration.minutes()
  duration.subtract(moment.duration(minutes, 'minutes'))

  const seconds = duration.seconds()

  if (days > 0) {
    // format: 1d 21h 3m 43s
    return t('common.format.timePreciseShorthandDaysIncluded', '', {
      days: days,
      hours: hours,
      mins: minutes,
      sec: seconds,
    })
  }

  // format: 0h 3m 43s
  return t('common.format.timePreciseShorthand', '', {
    hours: hours,
    mins: minutes,
    sec: seconds,
  })
}
